import { createApp } from 'vue'
import ContentCarousel from './ContentCarousel'

const el = '.kb-component--content-carousel'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM) {
        DOM.forEach((CarouselDOM) => {
            if (CarouselDOM.hasAttribute('data-v-app')) return false
            const props = {
                carouselId: CarouselDOM.id,
                contentJson: CarouselDOM.dataset.contentjson
                    ? JSON.parse(CarouselDOM.dataset.contentjson)
                    : [],
                glideBehaviour: CarouselDOM.dataset.glideBehaviour,
                type: CarouselDOM.dataset.type,
                link: CarouselDOM.dataset.link
                    ? JSON.parse(CarouselDOM.dataset.link)
                    : null
            }

            const component = createApp(ContentCarousel, props).use(Store)
            component.mount(CarouselDOM)
        })
    }
}
